export * from './departamentos.service';
export * from './galeria.service';
export * from './gtins.service';
export * from './marcas.service';
export * from './operadores.service';
export * from './produtos.service';
export * from './qtde.service';
